import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ContainerLoader } from '../../components/loader';

import { RouteKeys } from './route-keys';
import AuthenticateRoute from '../auth/AuthenticateRoute';

const Home = lazy(() => import('../home'));
const ForgotPassword = lazy(() => import('../forgot-password'));
const NotFound = lazy(() => import('../notfound'));
const SearchResult = lazy(() => import('../search-result'));
const Checkout = lazy(() => import('../checkout'));
const MyOrder = lazy(() => import('../my-order'));
const MyAccount = lazy(() => import('../my-account'));
const FAQ = lazy(() => import('../faq'));
const TermsOfService = lazy(() => import('../terms-of-use'));
const PrivacyPolicy = lazy(() => import('../privacy-policy'));
const SignUp = lazy(() => import('../sign-up'));
const BulkOrder = lazy(() => import('../bulk-order'));

class Routes extends React.Component {
  render() {
    return (
      <Suspense fallback={<ContainerLoader height={500} text={'Loading...'} />}>
        <Switch>
          <Route exact path={RouteKeys.Home} component={Home} />
          <Route exact path={RouteKeys.NotFound} component={NotFound} />
          <AuthenticateRoute
            exact
            path={RouteKeys.SearchResult}
            component={SearchResult}
          />
          <Route
            exact
            path={RouteKeys.ForgotPassword}
            component={ForgotPassword}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Checkout}
            component={Checkout}
          />
          <AuthenticateRoute
            // exact
            path={RouteKeys.MyOrder}
            component={MyOrder}
          />
          <AuthenticateRoute exact path={RouteKeys.FAQ} component={FAQ} />
          <AuthenticateRoute path={RouteKeys.MyAccount} component={MyAccount} />
          <AuthenticateRoute
            exact
            path={RouteKeys.TermsOfService}
            component={TermsOfService}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.PrivacyPolicy}
            component={PrivacyPolicy}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.BulkOrder}
            component={BulkOrder}
          />
          <Route exact path={RouteKeys.SignUp} component={SignUp} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    );
  }
}

export default Routes;
